import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import myBadgeImg from '../../images/my-img.jpg';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
    root: {
      maxWidth: 345,
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    avatar: {
      backgroundColor: red[500],
    },
  }));

const BlogInfo = (props) => {
    const {name, image, description, date, blogLink, animate} = props.blog;
    const classes = useStyles();
    
    return (
        <div className="col-12 col-md-6 col-lg-4 pro-image blog-style aos-init" data-aos={animate}>
            <Card className={classes.root} id="zoom-in">
                <CardHeader
                    avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                        <Avatar src={myBadgeImg} alt="shahnewaz"></Avatar>
                    </Avatar>
                    }
                    action={
                    <IconButton aria-label="settings" className="text-white">
                        <MoreVertIcon />
                    </IconButton>
                    }
                    title={name}
                    subheader={date}
                />        
                <CardMedia
                    className={classes.media}
                    image={image}
                    title="Paella dish"
                />
                <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {description }
                        <Link href={blogLink} target="_blank" rel="noopener">
                             Read more
                        </Link>
                    </Typography>
                </CardContent>    
            </Card>
        </div>
    );
};

export default BlogInfo;